import {
    GrupoInterface,
    CadastroGrupoInterface,
} from "../../../Interfaces/Geral/Grupos/GrupoInterfaces";

import {
    CadastrarGupoService,
    ListarGruposService,
    GetGrupoService,
    ListarGruposVinculadosModuloService,
    DeletarGrupoService,
    AtualizarGrupoSerice,
} from "../../../Services/Geral/Grupos/GrupoService";
import { Controller } from "../../Controller";

export async function CadastrarGupoController(
    requestBody: CadastroGrupoInterface
) {
    return Controller(CadastrarGupoService(requestBody));
}

export async function DeletarGrupoController(idGrupo: number) {
    return Controller(DeletarGrupoService(idGrupo));
}

export async function AtualizarGrupoController(requestBody: GrupoInterface) {
    return Controller(AtualizarGrupoSerice(requestBody));
}

export async function GetGrupoController(idGrupo: number) {
    return Controller(GetGrupoService(idGrupo));
}

export async function ListarGruposController() {
    return Controller(ListarGruposService());
}

export async function ListarGruposAtivosController() {
    return ListarGruposController().then((res) =>
        res.filter((grupo) => grupo.FL_ATIVO)
    );
}

export async function ListarGruposVinculadosModuloController(idModulo: number) {
    return Controller(ListarGruposVinculadosModuloService(idModulo));
}
